import * as AWS from 'aws-sdk/global';
import S3 from 'aws-sdk/clients/s3';

/**
 * @typedef {DeleteObjectsInS3Args}
 * @property {string} bucketName The bucket name containing the objects to delete.
 * @property {string} bucketRegion The AWS region for the bucket
 * @property {string} identityPoolId The Cognito identity pool ID for the user
 * @property {S3.ObjectIdentifier[]} objects a list of ObjectIdentifier objects which specify which
 * objects to delete. Each object has a required `Key` and optional `VersionID` for the specific version to delete.
 */
interface DeleteObjectsInS3Args {
    bucketName: string;
    bucketRegion: string;
    identityPoolId: string;
    objects: S3.ObjectIdentifier[];
}

/**
 * Delete one or more objects from S3. Essentially just a wrapper around the SDK method:
 * https://docs.aws.amazon.com/AWSJavaScriptSDK/latest/AWS/S3.html#deleteObjects-property
 * @param obj
 * @param args {DeleteObjectsInS3Args}
 */
export const deleteObjectsInS3 = async (
    args: DeleteObjectsInS3Args,
): Promise<S3.DeleteObjectsOutput> => {
    const { bucketName, bucketRegion, identityPoolId, objects } = args;

    const credentials = new AWS.CognitoIdentityCredentials({
        IdentityPoolId: identityPoolId,
    });

    AWS.config.update({
        region: bucketRegion,
        credentials,
    });

    const s3 = new S3({
        params: { Bucket: bucketName },
        region: bucketRegion,
        credentials,
    });

    const params = {
        Bucket: bucketName,
        Delete: {
            Objects: objects,
        },
    };

    return s3.deleteObjects(params).promise();
};
